//TODO: Перенести сюда все данные из Tools.js

import {HslColor} from "../../types";
// @ts-ignore
import store from "../store.js";
import MessageHelper from "./MessageHelper";
/**
 * Вспомогательные функции
 */
export class Tool
{
    private static updateGameStateTimer: number|null = null;
    /**
     * Записать куку
     * @param name
     * @param date
     * @param value
     */
    public static setCookie(name: string, value: string, date: Date|null): void
    {
        try {
            if (date) {
                document.cookie = `${name}=${value}; path=/; expires="${date.toUTCString()};"`;
            } else {
                document.cookie = `${name}=${value}; path=/`;
            }
        } catch (e) {}
    }

    /**
     * Значение куки по имени
     * @param name
     */
    public static getCookie(name: string): string|undefined
    {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        if (parts.length == 2) {
            return (parts.pop() as string).split(";").shift();
        }
        return undefined;
    }

    /**
     * Имя браузера
     */
    public static getBrowserName(): string {
        const nAgt = navigator.userAgent;
        let browserName='';
        // In Opera 15+, the true version is after "OPR/"
        if (( nAgt.indexOf("OPR/")) != -1) {
            browserName = "Opera";
        }
        // In older Opera, the true version is after "Opera" or after "Version"
        else if (( nAgt.indexOf("Opera")) != -1) {
            browserName = "Opera";
        }
        // In MSIE, the true version is after "MSIE" in userAgent
        else if (( nAgt.indexOf("MSIE")) != -1) {
            browserName = "Microsoft Internet Explorer";
        }
        // In Chrome, the true version is after "Chrome"
        else if (( nAgt.indexOf("Chrome")) != -1) {
            browserName = "Chrome";
        }
        // In Safari, the true version is after "Safari" or after "Version"
        else if (( nAgt.indexOf("Safari")) != -1) {
            browserName = "Safari";
        }
        // In Firefox, the true version is after "Firefox"
        else if (( nAgt.indexOf("Firefox")) != -1) {
            browserName = "Firefox";
        }
        return browserName;
    }

    /**
     * Converts hex color string to hsl object
     * @param color color string in hex representation
     */
    public static hexToHsl(color: string): HslColor
    {
        const red = parseInt(color.substr(1, 2), 16) / 255;
        const green = parseInt(color.substr(3, 2), 16) / 255;
        const blue = parseInt(color.substr(5, 2), 16) / 255;

        const max = Math.max(red, green, blue);
        const min = Math.min(red, green, blue);

        const delta = max - min;

        let hue;
        if (delta === 0) {
            hue = 0;
        }
        else if (max === red) {
            hue = 60 * (((green - blue) / delta) % 6);
        }
        else if (max === green) {
            hue = 60 * (((green - blue) / delta) + 2);
        }
        else if (max === blue) {
            hue = 60 * (((green - blue) / delta) + 4);
        }

        const luminance = (max + min) / 2;
        const saturation = delta === 0 ? 0 : delta / (1 - Math.abs(2 * luminance - 1));

        return {hue, saturation, luminance};
    }

    /**
     * Конвертация из rgb в hex
     * @param rgb
     */
    public static rgbToHex (rgb: string): string
    {
        function trim (str: string) {
            return str.replace(/^\s+|\s+$/gm,'');
        }

        const inParts = rgb.substring(rgb.indexOf("(")).split(","),
            r = parseInt(trim(inParts[0].substring(1)), 10),
            g = parseInt(trim(inParts[1]), 10),
            b = parseInt(trim(inParts[2]), 10);
        const outParts = [
            r.toString(16),
            g.toString(16),
            b.toString(16)
        ];

        // Pad single-digit output values
        outParts.forEach(function (part, i) {
            if (part.length === 1) {
                outParts[i] = '0' + part;
            }
        });

        return ('#' + outParts.join(''));
    }

    /**
     * Определяем светлость света
     * @param color
     * @private
     */
    public static isDark(color: string): boolean|null
    {
        const bgLightness: number = this.hexToHsl(color).luminance;
        const shadowLightness: string = (bgLightness as number) >= 0.5 ? 'light' : 'dark';

        return shadowLightness === 'dark';
    }
    /**
     * CSRF токен
     */
    public static getCSRFToken(): string
    {
        const tokenContainer = $('meta[name="csrf-token"]');

        if (typeof tokenContainer === 'undefined') {
            return '';
        }

        const content = tokenContainer.attr('content');

        return typeof content === 'undefined' ? '' : content;
    }
    /**
     * CSRF токен
     */
    public static createPlayerFieldId(fieldName: string, playerId: string): string
    {
        return `player-${playerId}-${fieldName}`;
    }

    /**
     * Случайное число
     * @param min
     * @param max
     */
    public static getRandomNumber(min: number, max: number): number
    {
        let rand = min + Math.random() * (max + 1 - min);
        return Math.floor(rand);
    }

    /**
     * Запустить таймер на обновление стейта
     * @param delay
     */
    public static startUpdateGameStateTimer(delay: number): void
    {
        this.endUpdateGameStateTimer();
        this.updateGameStateTimer = window.setInterval(() => {
            MessageHelper.getState();
        }, delay);
    }

    /**
     * Остановить таймер на обновление стейта
     */
    public static endUpdateGameStateTimer(): void
    {
        if (this.updateGameStateTimer) {
            clearInterval(this.updateGameStateTimer);
        }
    }

    /**
     * Получить минуты из секунд
     * @param sec
     */
    public static getMinutesFromSeconds(sec: number): number
    {
        return Math.floor(sec / 60);
    }

    /**
     * Получить часы и минуты из секунд
     * @param sec
     */
    public static getHoursAndMinutesFromSeconds(sec: number): string
    {
        const h = Math.floor(sec / 3600);
        const m = Math.floor(sec % 3600 / 60);

        return `${h} h ${m} min`;
    }

    /**
     * Получить подстроку между двух строк
     * @param str
     * @param start
     * @param end
     */
    public static getStringBetween(str: string, start: string, end: string) {
        let stringResult = '';
        const result = str.match(new RegExp(start + "(.*)" + end));

        if (result && typeof result[1] !== 'undefined') {
            stringResult = result[1];
        }
        return stringResult;
    }

    /**
     * Сравнение двух объектов
     * @param obj1
     * @param obj2
     */
    public static objectsEqual = (obj1: Record<string, any>, obj2: Record<string, any>) => {
        return Object.keys(obj1).length === Object.keys(obj2).length
            && Object.keys(obj1).every(p => obj1[p] === obj2[p]);
    }
}
